exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".button-new-tag,.el-tag+.el-tag{margin-left:10px}.button-new-tag{height:32px;line-height:30px;padding-top:0;padding-bottom:0}.input-new-tag{width:90px;margin-left:10px;vertical-align:bottom}", "", {"version":3,"sources":["/workspace/src/views/platform/pages/PlatformTagTable.vue"],"names":[],"mappings":"AAIA,gCAFE,gBAAkB,CAQnB,AAND,gBAEE,YAAa,AACb,iBAAkB,AAClB,cAAe,AACf,gBAAkB,CACnB,AACD,eACE,WAAY,AACZ,iBAAkB,AAClB,qBAAuB,CACxB","file":"PlatformTagTable.vue","sourcesContent":["\n.el-tag + .el-tag {\n  margin-left: 10px;\n}\n.button-new-tag {\n  margin-left: 10px;\n  height: 32px;\n  line-height: 30px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.input-new-tag {\n  width: 90px;\n  margin-left: 10px;\n  vertical-align: bottom;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a8565e3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/platform/pages/PlatformTagTable.vue
// module id = 5188
// module chunks = 342